import Axios from 'axios'

const rescheduleService = {
  axios () {
    let AxiosInstance = Axios
    AxiosInstance.defaults.baseURL = process.env.TRACEABILITY_BASE_URL
    return AxiosInstance
  },
  getRescheduledOrders (orderId) {
    return this.axios().get('/exams/reschedule', {
      params: {
        os: orderId
      }
    })
  },
  getTotalRescheduledOrders () {
    return this.axios().get('/exams/reschedule/count')
  }
}

export default rescheduleService
